export function wrapNegative(value) {
  return value < 0 ? `(${value})` : `${value}`;
}

function simplifyRoot(value) {
  const root = Math.sqrt(value);
  if (Number.isInteger(root)) return String(root);

  for (let factor = Math.floor(root); factor >= 2; factor -= 1) {
    if (value % (factor ** 2) === 0) {
      const remainder = value / (factor ** 2);
      return remainder === 1 ? String(factor) : `${factor}\\sqrt{${remainder}}`;
    }
  }

  return `\\sqrt{${value}}`;
}

export function sideLengthLine({ name, from, to, squared }) {
  const [x1, y1] = from;
  const [x2, y2] = to;
  const dx = x2 - x1;
  const dy = y2 - y1;
  const differenceSquares = `${wrapNegative(dx)}^2+${wrapNegative(dy)}^2`;
  const sumOfSquares = `${dx ** 2}+${dy ** 2}`;
  const root = simplifyRoot(squared);
  const stages = [
    `\\sqrt{(${wrapNegative(x2)}-${wrapNegative(x1)})^2+(${wrapNegative(y2)}-${wrapNegative(y1)})^2}`,
    `\\sqrt{${differenceSquares}}`,
    `\\sqrt{${sumOfSquares}}`,
    `\\sqrt{${squared}}`,
    root,
  ].filter((stage, index, all) => index === 0 || stage !== all[index - 1]);

  return `|${name}|&=${stages.join("=")}`;
}

export function sideLengthsAligned(sides) {
  return `\\begin{aligned}${sides.map(sideLengthLine).join("\\\\")}\\end{aligned}`;
}
